import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const buttonStyles: {
  exportButton: SxProps<Theme>;
  exportButtonBox: SxProps<Theme>;
  feedbackButton: SxProps<Theme>;
} = {
  exportButton: {
    margin: '5pt',
    height: '30pt',
  },
  exportButtonBox: {
    marginRight: '12pt',
  },
  feedbackButton: {
    '& .MuiButton-endIcon': {
      marginLeft: '2pt',
    },
  },
};

export default buttonStyles;
